import { useSelector } from 'react-redux';
import { getNavigationControlState } from '../../Helpers/navigationControl';

/**
 * Hook to check if forward navigation on the current page is blocked by an
 * active navigation-control component.
 * This is abstracted to a hook to limit the state required for the parent component.
 */
const useIsForwardNavigationBlockedByNavigationControl = () => {
  const { currentPage } = useSelector((store) => store.navigation);
  const { pages } = useSelector((store) => store.paging);
  const components = useSelector((store) => store.components);

  const { isForwardBlocked: isForwardNavigationBlockedByNavigationControl } =
    getNavigationControlState({
      components,
      pageComponentIds: pages?.[currentPage],
    });

  return { isForwardNavigationBlockedByNavigationControl };
};

export default useIsForwardNavigationBlockedByNavigationControl;
